// extracted by mini-css-extract-plugin
export var activeDot = "_2r-c";
export var buttonContainer = "_2r-9";
export var channelButton = "_2r-a";
export var clickable = "_2r-d";
export var content = "_2r-0";
export var contentFull = "_2r-2";
export var contentThird = "_2r-1";
export var contentWrapper = "_2r-7";
export var description = "_2r-5";
export var heightShort = "_2r-f";
export var image = "_2r-3";
export var imageContainer = "_2r-4";
export var selectButton = "_2r-e";
export var spinnerContainer = "_2r-b";
export var titleContent = "_2r-8";
export var titleWrapper = "_2r-6";